import type { IconProps } from './types';

function LightbulbIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M12 0.75V3.5625M19.9552 4.04498L17.9665 6.03372M23.25 12H20.4375M3.5625 12H0.75M6.03418 6.03372L4.04544 4.04498M10.125 22.3125H13.875M12 6.375C8.8934 6.375 6.375 8.8934 6.375 12C6.375 14.2086 7.64785 16.1198 9.5 17.0403V19.0312H14.5V17.0403C16.3522 16.1198 17.625 14.2086 17.625 12C17.625 8.8934 15.1066 6.375 12 6.375Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { LightbulbIcon };
